import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const Sparkle = ({ size, color, style }) => {
  const pathLength = Math.random() * 0.5 + 0.5;
  const delay = Math.random() * 2;

  return (
    <motion.svg
      width={size}
      height={size}
      viewBox="0 0 160 160"
      fill="none"
      style={{
        position: "absolute",
        ...style,
      }}
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: [0, 1, 0], scale: [0, 1, 0] }}
      transition={{
        duration: 1.5,
        repeat: Infinity,
        delay,
        ease: "easeInOut",
      }}
    >
      <motion.path
        d="M80 0C80 0 84.2846 41.2925 101.496 58.504C118.707 75.7154 160 80 160 80C160 80 118.707 84.2846 101.496 101.496C84.2846 118.707 80 160 80 160C80 160 75.7154 118.707 58.504 101.496C41.2925 84.2846 0 80 0 80C0 80 41.2925 75.7154 58.504 58.504C75.7154 41.2925 80 0 80 0Z"
        fill={color}
        initial={{ pathLength: 0 }}
        animate={{ pathLength }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          delay,
          ease: "easeInOut",
        }}
      />
    </motion.svg>
  );
};

const MemoCardPreview = () => {
  const [isTapped, setIsTapped] = useState(false);

  // Generate random positions for sparkles
  const sparkles = Array.from({ length: 8 }, (_, i) => ({
    id: i,
    size: Math.random() * 20 + 10,
    color: `hsl(${Math.random() * 60 + 40}, 100%, 70%)`,
    style: {
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
    },
  }));

  return (
    <Box>
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <motion.div
          animate={{
            y: [0, -2, 0],
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          whileTap={{ scale: 1.02 }}
          onTapStart={() => setIsTapped(true)}
          onTapCancel={() => setIsTapped(false)}
          onTap={() => setIsTapped(false)}
        >
          <Box
            sx={{
              width: "100%",
              maxHeight: "calc(100vh - 40px)",
              bgcolor: "white",
              border: "2px solid #e2cdb2",
              borderRadius: "16px",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
              mx: "auto",
              p: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
              minHeight: 480,
              justifyContent: "flex-start",
              backgroundImage:
                "linear-gradient(to bottom, rgba(255,255,255,0.9), rgba(255,255,255,0.95)), url('/assets/paper-texture.png')",
              backgroundSize: "cover",
              backgroundBlendMode: "overlay",
              overflow: "hidden",
            }}
          >
            {/* Sparkles */}
            {sparkles.map((sparkle) => (
              <Sparkle
                key={sparkle.id}
                size={sparkle.size}
                color={sparkle.color}
                style={sparkle.style}
              />
            ))}

            {/* Sticker Element */}
            <Box
              sx={{
                position: "absolute",
                bottom: 16,
                right: 16,
                transform: "rotate(-3deg)",
                zIndex: 1,
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  color: "#666",
                  bgcolor: "rgba(255,255,255,0.9)",
                  p: "4px 8px",
                  borderRadius: "12px",
                  border: "1px dashed #e2cdb2",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                💌 From you
              </Typography>
            </Box>

            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                pt: 2,
                pb: 2,
              }}
            >
              <Box
                sx={{
                  width: "90%",
                  overflow: "hidden",
                  bgcolor: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "8px",
                  boxShadow: "inset 0 2px 4px rgba(0,0,0,0.05)",
                }}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/assets/memo-cards/mothers-day/bg1.svg`}
                  alt="Mother's Day floral"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </Box>
            </Box>
            <Box sx={{ width: "100%", pt: 0, px: 2, textAlign: "center" }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 500,
                  fontSize: "2rem",
                  color: "#222",
                  mb: 0,
                  textShadow: "0 1px 2px rgba(0,0,0,0.05)",
                }}
              >
                Happy Mother's Day!
              </Typography>
            </Box>
          </Box>
        </motion.div>
      </motion.div>
      {/* <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          mt: 2,
        }}
      >
        <Typography
          sx={{
            fontStyle: "italic",
            fontSize: "1.08rem",
            color: "#222",
            opacity: 0.7,
          }}
        >
          click to open →
        </Typography>
      </Box> */}
    </Box>
  );
};

export default MemoCardPreview;
